import { render, staticRenderFns } from "./tipspop.vue?vue&type=template&id=4146c828&"
import script from "./tipspop.vue?vue&type=script&lang=js&"
export * from "./tipspop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports